import React from 'react';
import BagList from './components/BagList/BagList';

const BagPage = () => {
    return <BagList />;
};

export default BagPage;
